import React, {forwardRef, useEffect, useState} from 'react';

const Acordeon = forwardRef((props, ref) => {
  const [availableFooters, setAvailableFooters] = useState([]);
  const { availableTypes } = props;
  useEffect(() => {
    // Definir todos los posibles footers con sus configuraciones
    const allFootersConfigs = [
      {
        nombre: 'Terminos',
        titulo: 'Términos y Condiciones',
        split: 'split--close',
        icon: '1',
        idEnvoltura: 'splitTop-terminos',
        idCuerpo: 'split-terminos-cuerpo',
      },
      {
        nombre: 'Abrir',
        titulo: 'Abrir cuenta de ahorro BBVA',
        split: 'split--close',
        icon: '1',
        idEnvoltura: 'splitTop-abrir',
        idCuerpo: 'split-abrir-cuerpo',
      }
    ];

    let footersToShow = [];

    // Si se proporcionaron tipos específicos, usar esos
    if (availableTypes && Array.isArray(availableTypes) && availableTypes.length > 0) {
      footersToShow = allFootersConfigs.filter(footer => 
        availableTypes.includes(footer.nombre)
      );
    } else {
      // Si no se especificaron tipos, incluir todos los posibles
      footersToShow = [...allFootersConfigs];
    }

    // Permitir renderizar todos los footers disponibles para que se creen los elementos DOM
    setAvailableFooters(footersToShow);
  }, [availableTypes]); // Se actualizará cuando cambien los tipos disponibles

  /**
   * @param {*} evt 
   * @param {*} idCuerpo 
   * @param {*} idEnvoltura 
   */
  function onClick (evt, idCuerpo, idEnvoltura) {

    let oTarget = evt.target;
    let sTagName = oTarget.tagName;
    let oI = (sTagName=='BUTTON') ? oTarget.querySelector('i') : oTarget.parentElement.querySelector('i');

    let oCuerpo = document.getElementById(idCuerpo);
    let oEnvoltura = document.getElementById(idEnvoltura);
    let heightEnvoltura = oEnvoltura.getBoundingClientRect().height;
    if (oCuerpo.style.minHeight==='0px') {
      oCuerpo.style.minHeight = (heightEnvoltura + 50) + 'px';
      oI.className = 'split__icon icon ui-minus';
    } else {
      oCuerpo.style.minHeight = '0px';
      oI.className = 'split__icon icon ui-plus';
    }
  }  return availableFooters.length > 0 ? (
    availableFooters.map((datos) => (
      <div className='footerComp__split split__contenido' key={datos.nombre}>
        <h2>
          <button id={datos.nombre} className='split__cabecera' 
            onClick={(evt) => onClick(evt, datos.idCuerpo, datos.idEnvoltura)}>
            <span>{datos.titulo}</span>
            <i className={datos.icon === '1' ?  'split__icon icon ui-plus' :'split__icon icon ui-minus'}></i>
          </button>
        </h2>
        <div ref={datos.nombre === availableFooters[0].nombre ? ref : null} className={`split__cuerpo split--bot ${datos.split}`} id={datos.idCuerpo} style={{minHeight:'0px'}}>
          <div id={datos.idEnvoltura} className='split__cuerpo-envoltura'>
            <div className='split__texto-imagenes texto-bbva--500' id={`footer${datos.nombre}`}></div>
          </div>
        </div>
      </div>      
    ))
  ) : (
    <div className="no-footers" style={{ display: 'none' }}>
      <div ref={ref} id="empty-footer-container"></div>
    </div>
  );
});

export default Acordeon;